/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useGetDadosDaUnidade } from "services/api/SimuladorRepasseAssociativo/get-dados-da-unidade";
import { useGetCodigoFicha } from "services/api/SimuladorRepasseAssociativo/get-codigo-ficha";
import { useResumoPagamento } from "services/api/SimuladorRepasseAssociativo/post-resumo-pagamento";
import { useGerarFluxo } from "services/api/SimuladorRepasseAssociativo/post-gerar-fluxo";
import { useAplicarDesconto } from "services/api/SimuladorRepasseAssociativo/put-aplicar-desconto";
import MaterialUI from "material-UI";
import { useAplicarPosChaves } from "services/api/SimuladorRepasseAssociativo/put-aplicar-pos-chaves";
import {
  AcaoFormaPagamento,
  useValidarProposta,
} from "services/api/SimuladorRepasseAssociativo/post-validar-proposta";
import {
  resetarAlertasCiencia,
  sincronizarAlertasDaEtapa,
} from "utils/alertaCiencia";
import AlertaCienciaModal from "components/AlertaCienciaModal";
import LoadingOverlay from "components/LoadingOverlay";
import * as S from "./styles";
import NavCommon from "../../components/@navHeader";
import DadosDaUnidade from "./components/DadosDaUnidade";
import DadosAvaliacaoCredito from "./components/DadosAvaliacaoCredito";
import ResumoPagamento from "./components/ResumoPagamento";
import Campanha from "./components/Campanha";
import PagamentoDetalhado from "./components/PagamentoDetalhado";

// O backend não envia um identificador nos alertas, então o alerta de
// enquadramento só pode ser reconhecido pelo texto do título.
const temAlertaEnquadramento = (...listasDeAlertas: any[]) =>
  listasDeAlertas.some((alertas) =>
    (alertas || []).some((alerta: any) =>
      (alerta?.titulo || "").toLowerCase().includes("enquadr")
    )
  );

export function SimuladorRepasseAssociativo() {
  const params: any = useParams();
  const history = useHistory();
  const [errorNomeComprador, setErrorNomeComprador] = useState(false);
  const [errorRendaFamiliar, setErrorRendaFamiliar] = useState(false);
  const [errorTotalAprovadoFinanciamento, setErrorTotalAprovadoFinanciamento] =
    useState(false);
  const [errorValorCapacidadeMensal, setErrorValorCapacidadeMensal] =
    useState(false);
  const [errorAto, setErrorAto] = useState(false);
  const [isFichaLinked, setIsFichaLinked] = useState(false);
  const [saveValueReal, setSaveValueReal] = useState("");
  const [isFieldFocused, setIsFieldFocused] = useState(false);
  const [dataEditarSerie, setDataEditarSerie] = useState<any>(null);
  const [fluxoResetado, setFluxoResetado] = useState(false);
  // Editar uma série (mensais/anuais) personaliza a forma de pagamento. A API
  // não devolve esse estado de forma confiável e `dataEditarSerie` é limpo ao
  // recalcular o fluxo, então guardamos a intenção do usuário aqui.
  // `null` = nada aconteceu nesta sessão (não afirmamos nada ao backend),
  // `true` = série editada, `false` = fluxo resetado (volta para padrão).
  const [serieEditadaManualmente, setSerieEditadaManualmente] = useState<
    boolean | null
  >(null);
  // Regra do botão abaixo do resumo: com o fluxo já gerado, mexer nas sessões
  // de cima (avaliação de crédito / resumo de pagamento) transforma "Resetar
  // Fluxo" em "Recalcular Fluxo", até que o recálculo conclua com sucesso.
  const [sessoesSuperioresAlteradas, setSessoesSuperioresAlteradas] =
    useState(false);

  // Uma nova visita à tela deve voltar a avisar tudo do zero.
  useEffect(() => resetarAlertasCiencia, []);

  const [formCredito, setFormCredito] = useState({
    nomeComprador: "",
    codigoFicha: "",
    rendaFamiliar: "",
    totalAprovadoFinanciamento: "",
    valorFgts: "",
    subsidio: "",
    valorCapacidadeMensal: "",
    beneficioExtra: "",
  });

  const [formResumoPagamento, setFormResumoPagamento] = useState({
    ato: "",
    anualSolicitada: "",
    proSolutoPosChavesRadio: "2",
    descontoSolicitadoRadio: "0",
    porcentagem: "",
    numeroParcelas: "",
    descontoSolicitadoInput: "",
    valorDesconto: "",
    valorPropostaUnidade: "",
    avaliacaoConsiderada: "",
    fgtsSubsidio: "",
    financiamentoUtilizado: "",
    fgtsUtilizado: "",
    pmtUtilizada: "",
    proSolutoPreChaves: "",
    proSolutoPreChaves2: "",
    proSolutoPosChaves: "",
    proSolutoPosChaves2: "",
    comprometimentoMensaisMedio: "",
    comprometimentoMensaisMaximo: "",
  });

  const { data: dataDadosUnidade, isLoading: isLoadingDadosUnidade } =
    useGetDadosDaUnidade({
      idUnidade: params.idUnidade,
      idLeadCorretor: params.idLeadCorretor,
    });

  const {
    data: dataFicha,
    refetch: refetchFicha,
    isFetching: isLoadingFicha,
    isError: isErrorFicha,
  } = useGetCodigoFicha({
    codigoFicha: formCredito?.codigoFicha,
    idUnidade: dataDadosUnidade?.idUnidade || params.idUnidade,
    idLeadCorretor: params.idLeadCorretor,
    idOportunidade: params.action === "editable" ? params.idOportunidade : null,
  });

  useEffect(() => {
    if (params.action === "editable") {
      refetchFicha();
    }
  }, []);

  useEffect(() => {
    if (dataFicha && params.action === "editable") {
      setFormCredito({
        nomeComprador: dataFicha?.nomeComprador,
        codigoFicha: dataFicha?.codigoFicha ? dataFicha?.codigoFicha : null,
        rendaFamiliar: dataFicha?.rendaFamiliar,
        totalAprovadoFinanciamento: dataFicha?.totalAprovadoFinanciamento,
        valorFgts: dataFicha?.valorFgts,
        subsidio: dataFicha?.subsidio,
        valorCapacidadeMensal: dataFicha?.valorCapacidadeMensal,
        beneficioExtra: dataFicha?.beneficioExtra || "",
      });
      setIsFichaLinked(true);

      if (dataFicha?.codigoFicha === null || dataFicha?.codigoFicha === "") {
        setIsFichaLinked(false);
      }
    }
  }, [dataFicha]);

  const handleCodigoFichaChange = (newCodigoFicha: string) => {
    setFormCredito((prevState) => ({
      ...prevState,
      codigoFicha: newCodigoFicha,
    }));

    // Se o novo código da ficha for diferente do código da ficha vinculada, limpa os campos e atualiza o estado
    if (newCodigoFicha === "" || newCodigoFicha !== dataFicha?.codigoFicha) {
      setFormCredito({
        nomeComprador: "",
        codigoFicha: newCodigoFicha,
        rendaFamiliar: "",
        totalAprovadoFinanciamento: "",
        valorFgts: "",
        subsidio: "",
        valorCapacidadeMensal: "",
        beneficioExtra: "",
      });
      setIsFichaLinked(false);
    }
  };

  // `isSucessGerarFluxo` só é declarado mais abaixo, mas `mutateResumoPagamento`
  // precisa saber se já existe fluxo gerado no momento da chamada.
  const fluxoGeradoRef = useRef(false);

  const {
    data: dataResumoPagamento,
    mutate: ativarResumoPagamento,
    isLoading: isLoadingResumoPagamento,
  } = useResumoPagamento();

  const mutateResumoPagamento = (
    valorReais?: any,
    excludeFinanciamentoUtilizado = false,
    valorPropostaOverride?: number,
    isConsulta = false
  ) => {
    // Uma consulta é o carregamento inicial da tela em modo de edição, não uma
    // alteração do usuário — não pode marcar o fluxo como desatualizado.
    if (!isConsulta && fluxoGeradoRef.current) {
      setSessoesSuperioresAlteradas(true);
    }

    ativarResumoPagamento({
      idEmpreendimento: dataDadosUnidade?.idEmpreendimento,
      idUnidade: dataDadosUnidade?.idUnidade,
      idLeadCorretor: params.idLeadCorretor,
      nomeComprador: formCredito?.nomeComprador,
      valorCapacPagtoMensal: formCredito?.valorCapacidadeMensal,
      valorAprovadoFinanciamento: formCredito?.totalAprovadoFinanciamento,
      financiamentoUtilizado: excludeFinanciamentoUtilizado
        ? ""
        : formResumoPagamento?.financiamentoUtilizado,
      fgtsUtilizado: formResumoPagamento?.fgtsUtilizado,
      valorProposta:
        valorPropostaOverride ||
        formResumoPagamento?.valorPropostaUnidade ||
        dataDadosUnidade?.valorTabela,
      rendaFamiliar: formCredito?.rendaFamiliar,
      valorFgts: formCredito?.valorFgts,
      subsidio: formCredito?.subsidio,
      ato: formResumoPagamento?.ato,
      anualSolicitada: formResumoPagamento?.anualSolicitada,
      desconto: valorReais || saveValueReal,
      beneficioExtra: formCredito?.beneficioExtra,
      idOportunidade:
        isConsulta && params.action === "editable"
          ? params.idOportunidade
          : null,
    });
  };

  useEffect(() => {
    if (!dataResumoPagamento?.data) return;
    sincronizarAlertasDaEtapa(
      "resumo-pagamento",
      dataResumoPagamento.data.alertas
    );
  }, [dataResumoPagamento?.data]);

  useEffect(() => {
    if (params.action === "editable" && dataFicha) {
      mutateResumoPagamento(undefined, false, undefined, true);
    }
  }, [dataFicha]);

  const {
    data: dataAplicarDesconto,
    mutate: mutateAplicarDesconto,
    status: statusAplicarDesconto,
  } = useAplicarDesconto({
    valorDeTabelaUnidade: dataDadosUnidade?.valorTabela,
    valorReaisDesconto:
      formResumoPagamento?.descontoSolicitadoRadio === "1"
        ? formResumoPagamento?.descontoSolicitadoInput
        : null,
    valorPorcentagemDesconto:
      formResumoPagamento?.descontoSolicitadoRadio === "2"
        ? formResumoPagamento?.descontoSolicitadoInput
        : null,
  });

  const handleVincularCredito = () => {
    refetchFicha();
  };

  const {
    data: dataPosChaves,
    mutate: mutatePosChaves,
    status: statusPosChaves,
  } = useAplicarPosChaves();

  const {
    data: dataGerarFluxo,
    mutate: mutateGerarFluxo,
    isSuccess: isSucessGerarFluxo,
    status: statusGerarFluxo,
  } = useGerarFluxo();

  fluxoGeradoRef.current = isSucessGerarFluxo;

  const {
    data: dataValidarProposta,
    mutate: mutateValidarProposta,
    isLoading: isLoadingValidarProposta,
  } = useValidarProposta();

  // A validação é disparada depois que as respostas do resumo/fluxo já
  // atualizaram o formulário, então lemos o estado por ref para não usar
  // valores defasados do render em que o efeito foi agendado.
  const formCreditoRef = useRef(formCredito);
  formCreditoRef.current = formCredito;

  const formResumoPagamentoRef = useRef(formResumoPagamento);
  formResumoPagamentoRef.current = formResumoPagamento;

  // Regra: sair de um campo sem ter mudado o valor não pode disparar
  // processamento nem loading. Guardamos os formulários no momento em que
  // qualquer campo recebe o foco e comparamos no onBlur.
  const formsAoFocar = useRef<string | null>(null);

  useEffect(() => {
    const capturarSnapshot = (evento: FocusEvent) => {
      // Só campos de texto interessam: radios, checkboxes e botões não são
      // seguidos de um onBlur que dispara processamento, e deixá-los
      // sobrescrever o snapshot faria a comparação ser feita contra o estado
      // errado.
      const alvo = evento.target as HTMLElement | null;
      if (!(alvo instanceof HTMLInputElement)) return;
      if (alvo.type !== "text" && alvo.type !== "number") return;

      formsAoFocar.current = JSON.stringify({
        credito: formCreditoRef.current,
        resumo: formResumoPagamentoRef.current,
      });
    };

    // `focusin` sobe na árvore, então um único listener cobre todos os campos
    // da tela sem precisar plugar onFocus em cada um.
    document.addEventListener("focusin", capturarSnapshot);
    return () => document.removeEventListener("focusin", capturarSnapshot);
  }, []);

  // Retorna true se algum campo mudou desde o foco. Quando não há snapshot
  // (blur sem foco registrado), assumimos que houve alteração para não
  // bloquear um processamento legítimo.
  const houveAlteracaoDesdeFoco = () => {
    if (formsAoFocar.current === null) return true;

    const agora = JSON.stringify({
      credito: formCreditoRef.current,
      resumo: formResumoPagamentoRef.current,
    });

    return agora !== formsAoFocar.current;
  };

  const handleValidarProposta = () => {
    const credito = formCreditoRef.current;
    const resumo = formResumoPagamentoRef.current;

    const anualPersonalizada =
      dataEditarSerie?.data?.anualPersonalizada === true ||
      dataResumoPagamento?.data?.anualPersonalizada === true ||
      dataGerarFluxo?.data?.anualPersonalizada === true;

    // Só decidimos a forma de pagamento quando o usuário agiu sobre ela NESTA
    // sessão: série editada (personalizada) ou fluxo resetado (volta ao padrão).
    // Sem ação nenhuma — caso do F5, ou de mexer só no desconto — mandamos
    // `Manter` e o backend preserva o que já estava salvo.
    let acaoFormaPagamento = AcaoFormaPagamento.Manter;
    if (serieEditadaManualmente === true) {
      acaoFormaPagamento = AcaoFormaPagamento.DefinirPersonalizada;
    } else if (serieEditadaManualmente === false) {
      // Não existe ação de "resetar": voltar ao padrão é DefinirPadrao.
      acaoFormaPagamento = AcaoFormaPagamento.DefinirPadrao;
    } else if (anualPersonalizada) {
      acaoFormaPagamento = AcaoFormaPagamento.DefinirPersonalizada;
    }

    mutateValidarProposta({
      idLeadCorretor: params.idLeadCorretor,
      idUnidade: params.idUnidade,
      // Só existe no fluxo "editable"; em simulação nova a proposta ainda não
      // foi criada e mandamos null.
      idOportunidade:
        params.action === "editable" ? params.idOportunidade : null,
      acaoFormaPagamento,
      percentualDesconto:
        resumo?.descontoSolicitadoRadio === "2"
          ? resumo?.descontoSolicitadoInput
          : resumo?.valorDesconto,
      percentualProSoluto: resumo?.proSolutoPreChaves2,
      valorAnual: resumo?.anualSolicitada,
      valorRenda: credito?.rendaFamiliar,
      percentualComprometimentoPico: resumo?.comprometimentoMensaisMaximo,
      // O alerta de enquadramento indica que a renda NÃO está enquadrada.
      rendaEnquadrada: !temAlertaEnquadramento(
        dataResumoPagamento?.data?.alertas,
        dataGerarFluxo?.data?.alertas
      ),
      // Vêm da resposta de resumo-pagamento. gerar-fluxo/editar-serie também
      // recalculam a avaliação, então preferimos o valor mais recente.
      avaliacaoConsiderada:
        dataEditarSerie?.data?.avaliacaoConsiderada ??
        dataGerarFluxo?.data?.avaliacaoConsiderada ??
        dataResumoPagamento?.data?.avaliacaoConsiderada ??
        null,
      valorAvaliacao:
        dataEditarSerie?.data?.valorAvaliacao ??
        dataGerarFluxo?.data?.valorAvaliacao ??
        dataResumoPagamento?.data?.valorAvaliacao ??
        null,
    });
  };

  // Revalida sempre que uma das respostas que alimentam a proposta chega:
  // resumo-pagamento (onBlur dos campos), gerar-fluxo e editar-serie
  // (Salvar Alterações/Recalcular). O setTimeout garante que o formulário já
  // foi atualizado por essas respostas antes de montarmos o payload.
  useEffect(() => {
    if (!dataResumoPagamento?.data) return undefined;

    const timeoutId = setTimeout(() => handleValidarProposta(), 0);
    return () => clearTimeout(timeoutId);
  }, [
    dataResumoPagamento,
    dataGerarFluxo,
    dataEditarSerie,
    serieEditadaManualmente,
  ]);

  const formatCurrency = (value: number) => {
    if (!value && value !== 0) return "";

    const valorString = value.toString();
    const valorNumerico = parseFloat(valorString);

    return valorNumerico.toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  useEffect(() => {
    if (dataGerarFluxo) {
      setFormResumoPagamento((prevState) => ({
        ...prevState,
        financiamentoUtilizado: formatCurrency(
          dataGerarFluxo?.data?.financiamentoUtilizado
        ),
      }));
    }
  }, [dataGerarFluxo]);

  // Quando dataEditarSerie é atualizado e tem anualPersonalizada: true,
  // reseta fluxoResetado para false para que o campo seja bloqueado novamente
  useEffect(() => {
    if (dataEditarSerie?.data?.anualPersonalizada === true) {
      setFluxoResetado(false);
    }
  }, [dataEditarSerie?.data?.anualPersonalizada]);

  const handleGerarFluxo = (atualizarFluxoValue: boolean) => {
    // `isSucessGerarFluxo` aqui significa que já existe um fluxo gerado, ou
    // seja, esta chamada é um reset.
    const estaResetando = isSucessGerarFluxo;

    // Libera o campo "Anual Solicitada" já no clique (feedback imediato). A
    // forma de pagamento, ao contrário, NÃO pode ser marcada como resetada
    // aqui: se o gerar-fluxo falhar, o fluxo continua personalizado e avisar
    // o backend que voltou ao padrão perderia a personalização de verdade.
    // Por isso a intenção de reset só é confirmada no onSuccess.
    if (estaResetando) {
      setDataEditarSerie(null);
      setFluxoResetado(true);
    } else {
      setFluxoResetado(false);
    }

    // Usar setTimeout para garantir que o estado seja atualizado antes da mutação
    setTimeout(() => {
      mutateGerarFluxo(
        {
          idLeadCorretor: params.idLeadCorretor,
          idUnidade: params.idUnidade,
          idEmpreendimento: dataDadosUnidade?.idEmpreendimento,
          valorAto: formResumoPagamento?.ato,
          valorAnualSolicitada: formResumoPagamento?.anualSolicitada,
          porcentagemProSolutoPosChaves: formResumoPagamento?.porcentagem,
          numeroParcelasProSolutoPosChaves: formResumoPagamento?.numeroParcelas,
          proSolutoPosChaves:
            formResumoPagamento?.proSolutoPosChavesRadio === "1",
          descontoReais:
            formResumoPagamento?.descontoSolicitadoRadio === "1"
              ? formResumoPagamento?.descontoSolicitadoInput
              : formResumoPagamento?.valorDesconto,
          descontoSolicitadoEnum: formResumoPagamento?.descontoSolicitadoRadio,
          descontoPorcentagem:
            formResumoPagamento?.descontoSolicitadoRadio === "2"
              ? formResumoPagamento?.descontoSolicitadoInput
              : formResumoPagamento?.valorDesconto,
          valorProposta: formResumoPagamento?.valorPropostaUnidade,
          valorTabela: dataDadosUnidade?.valorTabela,
          rendaFamiliar: formCredito?.rendaFamiliar,
          fgts: formResumoPagamento?.fgtsUtilizado,
          subsidio: formCredito?.subsidio,
          valorFinanciamento: formResumoPagamento?.financiamentoUtilizado,
          valorPMTUtilizada: formResumoPagamento?.pmtUtilizada,
          proSolutoPreChavesReais: formResumoPagamento?.proSolutoPreChaves,
          proSolutoPreChavesPorcentagem:
            formResumoPagamento?.proSolutoPreChaves2,
          proSolutoPosChavesReais: formResumoPagamento?.proSolutoPosChaves,
          proSolutoPosChavesPorcentagem:
            formResumoPagamento?.proSolutoPosChaves2,
          comprometimentoMensalMedio:
            formResumoPagamento?.comprometimentoMensaisMedio,
          comprometimentoMensalMaximo:
            formResumoPagamento?.comprometimentoMensaisMaximo,
          numeroFicha: formCredito?.codigoFicha
            ? formCredito?.codigoFicha
            : null,
          atualizarFluxo: atualizarFluxoValue,
        },
        {
          onSuccess: (data) => {
            const toReal = (value: number) =>
              value?.toLocaleString("pt-br", { minimumFractionDigits: 2 }) ||
              "";
            setFormResumoPagamento((prevState) => ({
              ...prevState,
              comprometimentoMensaisMedio: toReal(
                data?.data?.comprometimentoMensaisMed
              ),
            }));
            setFormResumoPagamento((prevState) => ({
              ...prevState,
              comprometimentoMensaisMaximo: toReal(
                data?.data?.comprometimentoMensaisMax
              ),
            }));
            // O reset só aconteceu de fato agora: é aqui que a forma de
            // pagamento pode voltar a ser a padrão. Isso dispara a revalidação
            // com DefinirPadrao.
            //
            // Usamos `estaResetando` (e não `fluxoResetado`) porque o closure
            // enxerga o valor do render anterior ao setFluxoResetado(true).
            if (estaResetando) {
              setSerieEditadaManualmente(false);
              // Volta a permitir o bloqueio do campo caso anualPersonalizada
              // venha true de novo.
              setFluxoResetado(false);
            }

            // O fluxo voltou a refletir as sessões de cima: o botão sai de
            // "Recalcular Fluxo" e volta para "Resetar Fluxo".
            setSessoesSuperioresAlteradas(false);
          },
          onError: () => {
            // O fluxo continua como estava: desfaz a liberação otimista do
            // campo para a tela voltar a refletir o fluxo personalizado que
            // ainda está salvo. `serieEditadaManualmente` nunca foi tocado,
            // então a validação segue mandando Manter.
            if (estaResetando) {
              setFluxoResetado(false);
            }
          },
        }
      );
    }, 0);
  };

  useEffect(() => {
    if (!dataGerarFluxo?.data) return;
    sincronizarAlertasDaEtapa("gerar-fluxo", dataGerarFluxo.data.alertas);
  }, [dataGerarFluxo?.data]);

  // Carrega o fluxo já salvo apenas UMA vez, na abertura da tela em modo de
  // edição. Sem essa trava, cada POST de resumo-pagamento (onBlur dos campos)
  // dispararia um novo gerar-fluxo e sobrescreveria o pagamento detalhado sem
  // o usuário pedir — gerar um fluxo novo tem que ser ação explícita dele.
  const fluxoSalvoCarregado = useRef(false);

  useEffect(() => {
    if (
      params.action === "editable" &&
      dataResumoPagamento &&
      !fluxoSalvoCarregado.current
    ) {
      fluxoSalvoCarregado.current = true;
      mutateGerarFluxo({
        idOportunidade: params.idOportunidade,
      });
    }
  }, [dataResumoPagamento]);

  const handleValidateDadosAvaliacaoAto = (fieldName: string) => {
    let valid = true;

    if (formCredito.nomeComprador === "") {
      setErrorNomeComprador(true);
      valid = false;
    } else {
      setErrorNomeComprador(false);
    }

    if (
      formCredito.rendaFamiliar === "" ||
      formCredito.rendaFamiliar === "0,00"
    ) {
      setErrorRendaFamiliar(true);
      valid = false;
    } else {
      setErrorRendaFamiliar(false);
    }

    if (
      formCredito.totalAprovadoFinanciamento === "" ||
      formCredito.totalAprovadoFinanciamento === "0,00"
    ) {
      setErrorTotalAprovadoFinanciamento(true);
      valid = false;
    } else {
      setErrorTotalAprovadoFinanciamento(false);
    }

    if (
      formCredito.valorCapacidadeMensal === "" ||
      formCredito.valorCapacidadeMensal === "0,00"
    ) {
      setErrorValorCapacidadeMensal(true);
      valid = false;
    } else {
      setErrorValorCapacidadeMensal(false);
    }

    if (formResumoPagamento.ato === "" || formResumoPagamento.ato === "0,00") {
      setErrorAto(true);
      valid = false;
    } else {
      setErrorAto(false);
    }

    // Sair do campo sem ter alterado nada não dispara processamento: a
    // validação visual acima já rodou, mas não há por que chamar a API nem
    // abrir o loading. Os erros de campo continuam sendo atualizados.
    if (!houveAlteracaoDesdeFoco()) {
      return;
    }

    // Se todos os campos obrigatórios estiverem válidos, chama o mutateResumoPagamento
    if (
      valid &&
      formResumoPagamento.ato !== "" &&
      formResumoPagamento.ato !== "0,00"
    ) {
      const excludeFinanciamentoUtilizado =
        fieldName === "totalAprovadoFinanciamento";

      // Se o campo alterado foi o total de financiamento aprovado,
      // resetamos o financiamentoUtilizado para vazio.
      if (excludeFinanciamentoUtilizado) {
        setFormResumoPagamento((prev) => ({
          ...prev,
          financiamentoUtilizado: "",
        }));
      }

      mutateResumoPagamento(undefined, excludeFinanciamentoUtilizado);
    }
  };

  // O pagamento detalhado tem mutações próprias (editar valores mensais,
  // criar oportunidade). Ele informa aqui quando está processando para que o
  // overlay cubra a tela inteira, e não só a seção.
  const [processandoPagamentoDetalhado, setProcessandoPagamentoDetalhado] =
    useState(false);

  // Loading em tela cheia: aparece sempre que o sistema está processando algo
  // relevante, para não passar a sensação de travamento. A validação da
  // proposta fica de fora de propósito — ela roda em segundo plano depois de
  // cada resposta e não deve prender a tela.
  const processando =
    isLoadingDadosUnidade ||
    isLoadingFicha ||
    isLoadingResumoPagamento ||
    statusAplicarDesconto === "loading" ||
    statusPosChaves === "loading" ||
    statusGerarFluxo === "loading" ||
    processandoPagamentoDetalhado;

  // Botão abaixo do resumo de pagamento:
  // sem fluxo gerado        -> Gerar Fluxo
  // fluxo gerado e em dia   -> Resetar Fluxo
  // fluxo gerado e desatual.-> Recalcular Fluxo
  const precisaRecalcular = isSucessGerarFluxo && sessoesSuperioresAlteradas;

  let textoBotaoFluxo = "Gerar Fluxo";
  if (precisaRecalcular) {
    textoBotaoFluxo = "Recalcular Fluxo";
  } else if (isSucessGerarFluxo) {
    textoBotaoFluxo = "Resetar Fluxo";
  }

  let estiloBotaoFluxo: React.CSSProperties | undefined;
  if (precisaRecalcular) {
    estiloBotaoFluxo = { backgroundColor: "#F59E0B", color: "#ffffff" };
  } else if (isSucessGerarFluxo) {
    estiloBotaoFluxo = { backgroundColor: "#F43636", color: "#ffffff" };
  }

  const validateFields = (formCredito: any) => {
    if (formCredito.nomeComprador !== "") {
      setErrorNomeComprador(false);
    } else {
      setErrorNomeComprador(true);
    }

    if (
      formCredito.rendaFamiliar !== "" &&
      formCredito.rendaFamiliar !== "0,00"
    ) {
      setErrorRendaFamiliar(false);
    } else {
      setErrorRendaFamiliar(true);
    }

    if (
      formCredito.totalAprovadoFinanciamento !== "" &&
      formCredito.totalAprovadoFinanciamento !== "0,00"
    ) {
      setErrorTotalAprovadoFinanciamento(false);
    } else {
      setErrorTotalAprovadoFinanciamento(true);
    }

    if (
      formCredito.valorCapacidadeMensal !== "" &&
      formCredito.valorCapacidadeMensal !== "0,00"
    ) {
      setErrorValorCapacidadeMensal(false);
    } else {
      setErrorValorCapacidadeMensal(true);
    }
  };

  return (
    <>
      <NavCommon
        breadcrumbs={[
          {
            path:
              params.action === "editable"
                ? `/lead-detail/${params.idLeadCorretor}`
                : "/leads",
            name:
              params.action === "editable" ? `Detalhes do lead` : `Carteira`,
          },
          {
            path:
              params.action === "editable"
                ? `/lead-detail/${params.idLeadCorretor}/proposition-detail/${params.numeroCotacao}`
                : `/lead-detail/${params.idLeadCorretor}`,
            name:
              params.action === "editable" ? "Propostas" : "Detalhes do lead",
          },
          {
            path:
              params.action === "editable"
                ? `/lead-detail/${params.idLeadCorretor}/repasse-associativo/${params.idUnidade}/${params.idOportunidade}/${params.numeroCotacao}/editable`
                : `/lead-detail/${params.idLeadCorretor}/repasse-associativo/${params.idUnidade}`,
            name: "Simulador para PV Associativo",
          },
        ]}
        showButtonNew
        onBack={() => {
          history.goBack();
          localStorage.setItem("@sell.it/previousScreen", window.location.href);
        }}
        open
        onChangeActionNew={undefined}
      />
      <S.Container>
        <S.PageTitle>Simulador para PV Associativo</S.PageTitle>
        <S.BodyContainer>
          <S.ContentRow>
            <DadosDaUnidade
              dataDadosUnidade={dataDadosUnidade}
              isLoadingDadosUnidade={isLoadingDadosUnidade}
            />
            <S.Column>
              <DadosAvaliacaoCredito
                handleVincularCredito={handleVincularCredito}
                formCredito={formCredito}
                setFormCredito={setFormCredito}
                mutateResumoPagamento={mutateResumoPagamento}
                isLoadingFicha={isLoadingFicha}
                refetchFicha={refetchFicha}
                dataFicha={dataFicha}
                handleValidateDadosAvaliacaoAto={
                  handleValidateDadosAvaliacaoAto
                }
                errorNomeComprador={errorNomeComprador}
                errorRendaFamiliar={errorRendaFamiliar}
                errorTotalAprovadoFinanciamento={
                  errorTotalAprovadoFinanciamento
                }
                errorValorCapacidadeMensal={errorValorCapacidadeMensal}
                setErrorNomeComprador={setErrorNomeComprador}
                setErrorRendaFamiliar={setErrorRendaFamiliar}
                setErrorTotalAprovadoFinanciamento={
                  setErrorTotalAprovadoFinanciamento
                }
                setErrorValorCapacidadeMensal={setErrorValorCapacidadeMensal}
                validateFields={validateFields}
                isFichaLinked={isFichaLinked}
                setIsFichaLinked={setIsFichaLinked}
                handleCodigoFichaChange={handleCodigoFichaChange}
                isErrorFicha={isErrorFicha}
              />
              <Campanha dataDadosUnidade={dataDadosUnidade} />
            </S.Column>
          </S.ContentRow>
          <ResumoPagamento
            dataDadosUnidade={dataDadosUnidade}
            dataResumoPagamento={dataResumoPagamento}
            formResumoPagamento={formResumoPagamento}
            setFormResumoPagamento={setFormResumoPagamento}
            dataAplicarDesconto={dataAplicarDesconto}
            mutateAplicarDesconto={mutateAplicarDesconto}
            dataPosChaves={dataPosChaves}
            mutatePosChaves={mutatePosChaves}
            isLoadingResumoPagamento={isLoadingResumoPagamento}
            handleValidateDadosAvaliacaoAto={handleValidateDadosAvaliacaoAto}
            errorAto={errorAto}
            setErrorAto={setErrorAto}
            mutateResumoPagamento={mutateResumoPagamento}
            setSaveValueReal={setSaveValueReal}
            isFieldFocused={isFieldFocused}
            setIsFieldFocused={setIsFieldFocused}
            dataGerarFluxo={dataGerarFluxo}
            isSucessGerarFluxo={isSucessGerarFluxo}
            dataEditarSerie={dataEditarSerie}
            fluxoResetado={fluxoResetado}
          />
          <S.Button
            style={estiloBotaoFluxo}
            disabled={
              !dataResumoPagamento ||
              formResumoPagamento.ato === "" ||
              statusAplicarDesconto === "loading" ||
              statusPosChaves === "loading" ||
              isFieldFocused ||
              dataResumoPagamento?.data?.editavel === false
            }
            onClick={() => {
              handleGerarFluxo(true);
            }}
          >
            {statusGerarFluxo === "loading" ? (
              <MaterialUI.CircularProgress
                style={{ color: "#fff" }}
                size={22}
              />
            ) : (
              textoBotaoFluxo
            )}
          </S.Button>
          <PagamentoDetalhado
            setFormResumoPagamento={setFormResumoPagamento}
            formResumoPagamento={formResumoPagamento}
            dataGerarFluxo={dataGerarFluxo}
            handleGerarFluxo={handleGerarFluxo}
            isSucessGerarFluxo={isSucessGerarFluxo}
            setDataEditarSerie={setDataEditarSerie}
            setSerieEditadaManualmente={setSerieEditadaManualmente}
            dataValidarProposta={dataValidarProposta}
            isLoadingValidarProposta={isLoadingValidarProposta}
            setProcessando={setProcessandoPagamentoDetalhado}
          />
        </S.BodyContainer>
      </S.Container>
      <AlertaCienciaModal />
      <LoadingOverlay open={processando} />
    </>
  );
}
